/**
 * 全局mutations函数
 */
import localstore from "../utils/localStorge";

let mutations =  {
  setFarmId(state, payload) {
    // 判断缓存中是否存在farmId
    if (localstore.get("farmId") === null && !isNaN(payload.farmId)) {
      state.farmId = payload.farmId;
      localstore.set("farmId", state.farmId);
    } else {
      // 判断缓存中的 farmId 是否和获取到的 farmId 相同
      if (localstore.get("farmId") === payload.farmId) {
        state.farmId = localstore.get("farmId");
      } else {
        localstore.remove("farmId");
        localstore.remove("roomId");
        localstore.remove("isShowTips");
        localstore.remove("nowMonth");
        localstore.remove("nowProduct");
        localstore.remove("cropIndex");
        localstore.remove("envChartSelect");
        state.farmId = payload.farmId;
        localstore.set("farmId", state.farmId);
      }
    }
  },
  setRoomId(state, payload) {
    state.roomId = payload.roomId;
    // 当roomId改变时，清除上一次环境趋势一览的缓存
    if (localstore.get("roomId") !== null && localstore.get("roomId") !== payload.roomId) {
      localstore.set("roomId", state.roomId);
      localstore.remove("envChartSelect");
    }
  },
  setDeviceClass(state, payload) {
    state.deviceClass = payload.deviceClass;
  },
  setRoomList(state, payload) {
    state.roomList = payload.roomList;
    // 判断roomId缓存是否存在，优先使用缓存中的roomId
    if (localstore.get("roomId") === null) {
      state.roomId = payload.roomList.length > 0 ? payload.roomList[0].id : null;
      localstore.set("roomId", state.roomId);
    } else {
      state.roomId = localstore.get("roomId");
    }
  },
  setFruitCategory(state, payload) {
    state.fruitCategory = payload.fruitCategory;
  }
};

export default mutations;
